module.exports = __webpack_public_path__ + "static/media/storyNameThumbnial.59b5e654.png";